import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import {environment} from '../../../environments/environment';
import {UtilsService} from './utils.service';

import 'rxjs/add/operator/timeout';
import {map, catchError} from 'rxjs/operators';

@Injectable()
export class LocaleService {

    constructor(private http: HttpClient,
                private utilsService: UtilsService
    ) {
    }

    getLocaleByIp(): Observable<any> {
        return this.http
            .get<any>(environment.common.locale_api_url)
            .map((res: any) => {
                if (res) {
                    const countryName = res.country_name;
                    let locale: string;
                    if (countryName.indexOf('Korea') >= 0) {
                        locale = 'ko-kr';
                    } else {
                        locale = 'en';
                    }
                    return locale;
                } else {
                    return 'en';
                }
            }, error => {
                this.utilsService.debugLog(error);
                return environment.common.default_locale;
            })
            .timeout(5000)
            .catch(error => {
                return Observable.of(environment.common.default_locale);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/locale.service.ts